import React, { useState } from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import '../../css/OutPutDirectory.css'; // Import the CSS file
import { useSelector } from 'react-redux';
import { FORM_KEYS } from '../../utills/constant';

const OutPutDirectory = () => {
  const {formDetails,bucketName} = useSelector((state) => state.CreateAgentSlice);
  console.log('createAgent',bucketName)

  return (
    <Box sx={{ width: '38vw', marginLeft: 0, backgroundColor: '#EEF3F7', paddingTop: 2, borderRadius: 2 }}>
      {[
        {
          title: 'INPUT DIRECTORY',
          details: [
            { label: 'Directory', value: formDetails[FORM_KEYS.INPUT_DIRECTORY_ID] },
            { label: 'Url / path', value: formDetails[FORM_KEYS.INPUT_DIRECTORY_PATH_OR_ADDRESS] }
          ]
        },
        {
          title: 'BUCKET NAME',
          details: [
            { label: 'Name', value: bucketName?.data?.bucket_name },
          ]
        },
        {
          title: 'OUTPUT DIRECTORY',
          details: [
            { label: 'Directory', value: formDetails[FORM_KEYS.OUTPUT_DIRECTORY_ID] },
            { label: "Url's", value: formDetails[FORM_KEYS.OUTPUT_DIRECTORY_PATH_OR_ADDRESS] },
            { label: 'Formats', value: formDetails[FORM_KEYS.OUTPUT_FILE_FORMAT] }
          ]
        },
        {
          title: 'MOVED FILES',
          details: [
            { label: "Url's", value: formDetails[FORM_KEYS.PROCESSED_FILE_DIRECTORY_PATH_OR_ADDRESS] },
            { label: 'Formats', value: formDetails[FORM_KEYS.OUTPUT_FILE_FORMAT] }
          ]
        },
        {
          title: 'REJECTED FILES',
          details: [
            { label: "Url's", value: formDetails[FORM_KEYS.REJECTED_FILE_DIRECTORY_PATH_OR_ADDRESS] },
            { label: 'Formats', value: formDetails[FORM_KEYS.OUTPUT_FILE_FORMAT] }
          ]
        }
      ].map((section, index) => (
        <Card key={index} sx={{ marginBottom: 2, borderRadius: 2, boxShadow: 2 }}>
          <CardContent>
            <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: 1 }}>
              {section.title}
            </Typography>
            {section.details.map((detail, idx) => (
              <Box key={idx} sx={{ display: 'flex', justifyContent: 'space-between', backgroundColor: idx % 2 === 0 ? '#EEF3F7' : '#fff', padding: 1, borderRadius: 1 }}>
                <Typography sx={{ color: '#828282', fontSize: 16 }}>{detail.label}</Typography>
                <Typography sx={{ color: '#000', fontSize: 16 }}>{detail.value}</Typography>
              </Box>
            ))}
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default OutPutDirectory;
